import React, { FC, ReactNode } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import denticareTheme from 'config/denticare';

// STYLES
import { CheckInCheckOutWrapper } from './styles';

interface AppContainerProps {
  children: ReactNode;
}

const AppContainer: FC<AppContainerProps> = ({ children }) => (
  <CheckInCheckOutWrapper>
    <ChakraProvider theme={denticareTheme}>{children}</ChakraProvider>
  </CheckInCheckOutWrapper>
);

export default AppContainer;
